var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWindowRestoreSolid = function SvgWindowRestoreSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5v22h22V5Zm2 2h18v18H7Zm5 2v4H9v10h11v-4h3V9Zm2 2h7v1h-7Zm0 3h7v3h-7Zm-3 1h1v1.031h-1Zm0 3.031h1V19h6v2h-7Z"
  })));
};
export default SvgWindowRestoreSolid;